module.exports = __webpack_public_path__ + "img/singletrack-promo-right.e5652b96.png";